import {
  PRODUCT_MODEL_KEY,
  PRODUCT_MODEL_TYPE
} from 'models/daos/product/constants'
import getValueReduxUtil from 'modules/redux/utils/get-value'

function isPosterProductUtil (instance) {
  return getValueReduxUtil(
    instance,
    PRODUCT_MODEL_KEY.TYPE
  ) === PRODUCT_MODEL_TYPE.POSTER
}

export {
  isPosterProductUtil
}
